var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-page"},[_c('aboutMain'),_c('aboutBcn'),_c('aboutCodex'),_c('aboutSocial'),_c('aboutCertificate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }